import React from "react";

import passanger from '../../assets/passenger.png'
import goods from '../../assets/goods.png'
import heavy from '../../assets/heavy.png'
import emergency from '../../assets/emergency.png'
export default function VehicleCategories() {
  const categories = [
    {
      title: "Passenger Vehicles",
      desc: "Auto • Car • Traveller",
      img: passanger
    },
    {
      title: "Goods Transport",
      desc: "Mini Truck • Truck • Tractor",
      img: goods
    },
    {
      title: "Heavy Vehicles",
      desc: "JCB • Crane",
      img: heavy
    },
    {
      title: "Emergency Services",
      desc: "Ambulance",
      img:emergency
    }
  ];

  return (
    <section className="relative py-24 bg-gradient-to-b from-blue-50 to-white overflow-hidden">

      {/* Soft Background Blurs */}
      <div className="absolute -top-10 left-10 w-48 h-48 bg-blue-300 blur-[90px] opacity-40 rounded-full"></div>
      <div className="absolute bottom-0 right-10 w-48 h-48 bg-orange-300 blur-[90px] opacity-40 rounded-full"></div>

      <div className="relative max-w-7xl mx-auto px-6 text-center">
        
        {/* Heading */}
        <span className="bg-orange-100 text-trogoOrange px-4 py-1 rounded-full font-semibold text-small">
          Vehicle Categories
        </span>

        <h2 className="text-h1 md:text-5xl font-extrabold text-trogoBlue mt-4 leading-tight">
          One Platform. Multiple Vehicles.
        </h2>

        <p className="text-gray-600 max-w-3xl mx-auto mt-4 text-body">
          TROGO supports a wide range of vehicles to meet every transport requirement.
          No matter the load or distance — <span className="text-trogoOrange font-semibold">TROGO has you covered.</span>
        </p>

        {/* Categories Grid */}
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {categories.map((cat, i) => (
            <div
              key={i}
              className="glass-card rounded-[2rem] p-6 border border-white/80 shadow-xl hover:-translate-y-2 transition-transform duration-300"
            >
              <div className="flex justify-center">
                <img
                  src={cat.img}
                  alt={cat.title}
                  className="w-30 h-30 object-contain"
                />
              </div>

              <h3 className="mt-6 text-xl font-bold text-trogoBlue">
                {cat.title}
              </h3>

              <p className="text-gray-600 mt-2">{cat.desc}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
